import api from "./api";

const leaveService = {
    // ── Leave Types (Admin / Super Admin) ──────────────────────────────────
    getLeaveTypes: (params) => api.get("/leave-types", { params }),
    getLeaveTypeById: (id) => api.get(`/leave-types/${id}`),
    createLeaveType: (data) => api.post("/leave-types", data),
    updateLeaveType: (id, data) => api.put(`/leave-types/${id}`, data),
    deleteLeaveType: (id) => api.delete(`/leave-types/${id}`),

    // ── Leave Applications (Admin / Super Admin Review Queue) ──────────────
    getAllApplications: (params) => api.get("/leave-applications", { params }),
    getApplicationById: (id) => api.get(`/leave-applications/${id}`),
    approveApplication: (id, data = {}) => api.put(`/leave-applications/${id}/approve`, data),
    rejectApplication: (id, data = {}) => api.put(`/leave-applications/${id}/reject`, data),
    getEmployeeBalance: (employeeId, params) =>
        api.get(`/leave-applications/employee/${employeeId}/balance`, { params }),

    // ── Teacher Portal Self-Service ────────────────────────────────────────
    getMyLeaveBalance: () => api.get("/portal/teacher/leave/balance"),
    getMyLeaveApplications: () => api.get("/portal/teacher/leave"),
    submitMyLeaveApplication: (data) => api.post("/portal/teacher/leave", data),
};

export default leaveService;